import React from 'react';
import { FaFacebook, FaYoutube, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';

export const socialLinks = [
  {
    id: '1',
    label: 'Facebook',
    icon: <FaFacebook />,
    color: '#0084ff',
    url: 'https://www.facebook.com/solaricbd/',
  },
  {
    id: '2',
    label: 'YouTube',
    icon: <FaYoutube />,
    color: '#cd201f',
    url: 'https://www.youtube.com/channel/UCxYQTxmuhu9zqDG-5-MDHtw',
  },
  {
    id: '3',
    label: 'Twitter',
    icon: <FaTwitter />,
    color: '#55acee',
    url: 'https://twitter.com/Solaric_global',
  },
  {
    id: '4',
    label: 'LinkedIn',
    icon: <FaLinkedin />,
    color: '#0077B5',
    url: 'https://www.linkedin.com/company/74759071',
  },
  {
    id: '5',
    label: 'Instagram',
    icon: <FaInstagram />,
    color: '#e4405f',
    url: 'https://instagram.com/solaric.global?utm_medium=copy_link',
  },
];
